import React, { useEffect, useState } from "react";

const BannerV1 = () => {
  const [banners, setBanners] = useState([]);
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const fetchBannerData = async () => {
      try {
        const response = await fetch(
          "https://eventscons.com/eventbackendnew/api/banner-details"
        );
        const result = await response.json();

        if (result?.status && Array.isArray(result?.data)) {
          setBanners(result.data);
        }
      } catch (error) {
        console.error("Banner API fetch error:", error);
      }
    };

    fetchBannerData();
  }, []);

  useEffect(() => {
    if (banners.length <= 1) return;

    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % banners.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [banners]);

  const goToPrevSlide = () => {
    setCurrentSlide((prev) => (prev === 0 ? banners.length - 1 : prev - 1));
  };

  const goToNextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % banners.length);
  };

  const splitTitle = (title = "") => {
    const words = title.trim().split(" ").filter(Boolean);
    if (words.length <= 2) {
      return { firstPart: title, lastTwo: "" };
    }

    const lastTwo = words.slice(-2).join(" ");
    const firstPart = words.slice(0, -2).join(" ");
    return { firstPart, lastTwo };
  };

  return (
    <section
      className="banner-section"
      style={{
        position: "relative",
        height: "100vh",
        overflow: "hidden",
      }}
    >
      {banners.map((banner, index) => {
        const imageUrl = banner?.background_image?.[0];
        const { firstPart, lastTwo } = splitTitle(banner?.title || "");

        return (
          <div
            key={banner.id}
            style={{
              position: "absolute",
              inset: 0,
              backgroundImage: `linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.4)), url(${imageUrl})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              display: "flex",
              alignItems: "center",
              color: "white",
              fontFamily: "Arial, sans-serif",
              opacity: index === currentSlide ? 1 : 0,
              transition: "opacity 0.8s ease-in-out",
              zIndex: index === currentSlide ? 1 : 0,
            }}
          >
            <div
              className="container"
              style={{ paddingLeft: "8%", width: "100%" }}
            >
              <div className="content-box-two" style={{ maxWidth: "800px" }}>
                <p
                  style={{
                    fontSize: "1.2rem",
                    marginBottom: "15px",
                    fontWeight: "400",
                    opacity: "0.9",
                    color: "#fff",
                  }}
                >
                  Welcome To The Events Consultant
                </p>

                <h1
                  style={{
                    fontSize: "3rem",
                    fontWeight: "600",
                    margin: "0",
                    lineHeight: "1.1",
                    color: "#fff",
                  }}
                >
                  {firstPart}
                  {lastTwo && (
                    <>
                      <br />
                      {lastTwo}
                    </>
                  )}
                </h1>

                <p
                  style={{
                    fontSize: "1rem",
                    marginTop: "25px",
                    marginBottom: "35px",
                    lineHeight: "1.5",
                    fontWeight: "400",
                    maxWidth: "500px",
                    color: "#fff",
                    whiteSpace: "pre-line",
                  }}
                >
                  {banner?.description}
                </p>

                <div>
                  <a
                    href={banner?.button_link}
                    style={{
                      display: "inline-block",
                      backgroundColor: "#ac162c",
                      color: "white",
                      padding: "10px 35px",
                      border: "none",
                      fontSize: "1.1rem",
                      fontWeight: "600",
                      cursor: "pointer",
                      borderRadius: "0px",
                      transition: "0.3s",
                      textDecoration: "none",
                    }}
                  >
                    {banner?.button_text}
                  </a>
                </div>
              </div>
            </div>
          </div>
        );
      })}

      {banners.length > 1 && (
        <>
          <button
            onClick={goToPrevSlide}
            style={{
              position: "absolute",
              top: "50%",
              left: "20px",
              transform: "translateY(-50%)",
              zIndex: 5,
              background: "rgba(0,0,0,0.4)",
              color: "#fff",
              border: "none",
              padding: "10px 15px",
              cursor: "pointer",
              fontSize: "20px",
            }}
          >
            ‹
          </button>

          <button
            onClick={goToNextSlide}
            style={{
              position: "absolute",
              top: "50%",
              right: "20px",
              transform: "translateY(-50%)",
              zIndex: 5,
              background: "rgba(0,0,0,0.4)",
              color: "#fff",
              border: "none",
              padding: "10px 15px",
              cursor: "pointer",
              fontSize: "20px",
            }}
          >
            ›
          </button>

          <div
            style={{
              position: "absolute",
              bottom: "30px",
              left: "50%",
              transform: "translateX(-50%)",
              display: "flex",
              gap: "10px",
              zIndex: 5,
            }}
          >
            {banners.map((_, index) => (
              <span
                key={index}
                onClick={() => setCurrentSlide(index)}
                style={{
                  width: "12px",
                  height: "12px",
                  borderRadius: "50%",
                  background: index === currentSlide ? "#ac162c" : "#fff",
                  cursor: "pointer",
                  opacity: index === currentSlide ? 1 : 0.6,
                }}
              />
            ))}
          </div>
        </>
      )}
    </section>
  );
};

export default BannerV1;